export const USER_ROLE = {
  ARTIST: 'artist',
  USER: 'user',
};
